export const reviewsTeaser = {
  REVIEWS_TEASER: 'reviewsTeaser',
  REVIEWS_TEASER_TRANSLATIONS: 'reviewsTeaser.translation',
  REVIEWS_TEASER_ORIGINAL: 'reviewsTeaser.original',
  REVIEWS_TEASER_POPUP: 'reviewsTeaser.modal',
  REVIEWS_TEASER_SHOW_MORE: 'reviewsTeaser.showMore'
}
